import { createI18n } from 'vue-i18n'
import jaJP from '@/locales/ja-JP.json'
import type { MessageSchema, DefineNumberFormat, DefineDateTimeFormat } from '@/types/i18n'

const i18n = createI18n<
  {
    message: MessageSchema
    datetime: DefineDateTimeFormat
    number: DefineNumberFormat
  },
  'ja-JP'
>({
  legacy: false, // you must set `false`, to use Composition API
  locale: 'ja-JP',
  fallbackLocale: 'ja-JP',
  globalInjection: true,
  messages: {
    'ja-JP': jaJP
  },
  datetimeFormats: {
    'ja-JP': {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      },
      long: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        weekday: 'short',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
      }
    }
  },
  numberFormats: {
    'ja-JP': {
      currency: {
        style: 'currency',
        currency: 'JPY',
        useGrouping: true,
        currencyDisplay: 'symbol'
      },
      decimal: {
        style: 'decimal',
        minimumSignificantDigits: 3,
        maximumSignificantDigits: 5
      },
      percent: {
        style: 'percent',
        useGrouping: false
      }
    }
  }
})

export default i18n
